export const playerSelectorDroppableId = 'player-selector';
